import React from 'react';
import { Effect, Modal } from 'react-dynamic-modal';
import { X } from 'react-feather';
import { EVO } from '../EVO';
import { FeatherButton } from './FeatherButton';
import './PTModal.css';

export const PTModal = ({ children, ...props }) => {
    return <Modal
        effect={Effect.ScaleUp}
        style={
            {
                overlay: {
                    textAlign: 'center',
                    zIndex: 9999
                },

                content: {
                    width: 'auto',
                    display: 'inline-block',
                    borderRadius: '25px'
                }
            }
        }
        {...props}>
        <div className="pt-modal">
            <FeatherButton feather={<X />} onClick={EVO.closeModal} classNames="pt-modal-close" />
            {children}
            
            </div>
    </Modal>;
}


// WEBPACK FOOTER //
// ./src/components/PTModal.js